import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter } from 'lucide-react';

const AltioraFooter = () => {
  return (
    <footer className="bg-gray-900 text-white border-t-2 border-teal-600">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/">
              <img 
                src="https://customer-assets.emergentagent.com/job_landing-hub-396/artifacts/6qtmykc4_49f33f49-895b-4aa5-9fe3-65aa14ace4ce.jfif" 
                alt="Altiora Business Solutions"
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              End-to-end order-to-cash solutions for US small-cap companies. Competitive pricing, exceptional results, 24/7 support.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/" className="hover:text-teal-400 transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-teal-400 transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/industries" className="hover:text-teal-400 transition-colors">Industries</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-teal-400 transition-colors">About Us</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-teal-400 transition-colors">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-lg mb-4">Our Services</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>Accounts Receivable (AR)</li>
              <li>Accounts Payable (AP)</li>
              <li>Claims Recovery</li>
              <li>Customer Services</li>
              <li>Purchase Order Management</li>
              <li>Daily Invoicing Process</li>
              <li>Journal & Ledger Entries</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4">Get in Touch</h4>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 flex-shrink-0 mt-0.5 text-teal-400" />
                <a href="mailto:contact@altiora.co.in" className="hover:text-teal-400 transition-colors">
                  contact@altiora.co.in
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 flex-shrink-0 mt-0.5 text-teal-400" />
                <div>
                  <div>US: +1 (669) 245-6417</div>
                  <div>India: +91-9752582205</div>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5 text-teal-400" />
                <span>India Operations</span>
              </li>
            </ul>
            
            <div className="flex space-x-3 mt-4">
              <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors">
                <Twitter className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; 2025 Altiora Business Solutions. All rights reserved.</p>
          <p className="mt-2">Empowering businesses with exceptional accounting solutions</p>
        </div>
      </div>
    </footer>
  );
};

export default AltioraFooter;
